import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "screen-center"
}

import { onMounted } from 'vue';
import { useAccountStore } from './stores/account';
import TheDialogBase from './components/dialogs/TheDialogBase.vue';
import TheTooltipBase from './components/TheTooltipBase.vue';
import VLoader from './components/VLoader.vue';
import TheConfirmModal from './components/TheConfirmModal.vue';
import TheContextMenu from './components/TheContextMenu.vue';
import TheToasts from './components/TheToasts.vue';
import { useDialogStore } from './stores/dialogs';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const accountStore = useAccountStore()
const dialogStore = useDialogStore()
onMounted(() => {
   accountStore.init()
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(accountStore).status === 'init')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(VLoader)
        ]))
      : (_openBlock(), _createBlock(_component_router_view, { key: 1 })),
    _createVNode(TheDialogBase),
    _createVNode(TheConfirmModal),
    _createVNode(TheTooltipBase),
    _createVNode(TheContextMenu),
    _createVNode(TheToasts)
  ], 64))
}
}

})